export const WorkflowSetupDetailsDetails = [
    {
        title: 'Create Your First Workflow',
        content: 'Create a series of actions triggered by specific events in/outside of your community.',
    },
    {
        title: 'Activate Your Workflow',
        content: 'Activate your workflow to automate tasks.',
    },
];
